/* T FOR ALL — product card: rotate photos with arrows + color-swatch photo switch. */
(function () {
  function initCard(card) {
    if (card.dataset.cardInit) return;
    card.dataset.cardInit = '1';
    var slides = Array.prototype.slice.call(card.querySelectorAll('.tfa-card__slide'));
    if (!slides.length) return;
    var idx = 0;
    function show(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
    }
    var prev = card.querySelector('[data-card-prev]');
    var next = card.querySelector('[data-card-next]');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(idx - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(idx + 1); });

    card.querySelectorAll('[data-swatch-img]').forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault();
        var url = sw.getAttribute('data-swatch-img');
        var img = slides[0] && slides[0].querySelector('img');
        if (url && img) { img.removeAttribute('srcset'); img.src = url; }
        show(0);
        card.querySelectorAll('.tfa-card__swatch').forEach(function (s) { s.classList.remove('is-active'); });
        sw.classList.add('is-active');
      });
    });
  }
  /* Quick buy: delegated, so cards re-rendered by filters/sorting work too.
     Size without length -> add to cart. Size with lengths -> step 2 in the same overlay. */
  function baseSize(value) { return String(value).split(' (')[0].trim(); }

  function quickBuyData(overlay) {
    if (!overlay._qb) {
      var el = overlay.querySelector('[data-quick-buy-data]');
      try { overlay._qb = JSON.parse(el.textContent); } catch (e) { overlay._qb = null; }
    }
    return overlay._qb;
  }

  // Length of a variant: its own option, or "L36" inside the size ("XS (W34-L36)").
  function lengthOf(data, variant) {
    if (data.length) return variant.options[data.length - 1];
    var m = /\bL(\d{2,3})\b/.exec(variant.options[data.size - 1]);
    return m ? m[1] + '"' : null;
  }

  // Variants for a base size, limited to the colour picked under the card (default: first colour).
  function variantsFor(overlay, data, size) {
    var card = overlay.closest('[data-product-card]');
    var active = card && card.querySelector('.tfa-card__swatch.is-active');
    var color = data.color ? (active ? active.getAttribute('data-swatch-value') : data.variants[0].options[data.color - 1]) : null;
    return data.variants.filter(function (v) {
      return baseSize(v.options[data.size - 1]) === size && (!color || v.options[data.color - 1] === color);
    });
  }

  function showStep(overlay, lengths) {
    // Keep the overlay as tall as the size list, so step 2 doesn't jump
    overlay.style.minHeight = lengths ? overlay.offsetHeight + 'px' : '';
    overlay.querySelector('[data-quick-buy-sizes]').hidden = lengths;
    overlay.querySelector('[data-quick-buy-lengths]').hidden = !lengths;
  }

  function addToCart(trigger, variantId, fallbackUrl) {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { id: variantId, quantity: 1 };
    if (cart) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      cart.setActiveElement(trigger);
    }
    trigger.setAttribute('aria-busy', 'true');
    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify(body);
    fetch(window.routes.cart_add_url, config)
      .then(function (r) { return r.json(); })
      .then(function (response) {
        // Sold out or another error: the product page shows the reason
        if (response.status) { window.location.href = fallbackUrl; return; }
        if (!cart) { window.location.href = window.routes.cart_url; return; }
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(response);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: variantId, cartData: response });
        }
        var overlay = trigger.closest('[data-quick-buy]');
        if (overlay) showStep(overlay, false);
      })
      .catch(function () { window.location.href = fallbackUrl; })
      .finally(function () { trigger.removeAttribute('aria-busy'); });
  }

  document.addEventListener('click', function (e) {
    var overlay = e.target.closest('[data-quick-buy]');
    if (!overlay) return;
    var data = quickBuyData(overlay);
    if (!data || !window.routes || typeof fetchConfig !== 'function') return; // fall back to the product link

    var sizeLink = e.target.closest('[data-quick-buy-size]');
    var lengthBtn = e.target.closest('[data-quick-buy-length]');
    if (e.target.closest('[data-quick-buy-back]')) {
      e.preventDefault();
      showStep(overlay, false);
      var first = overlay.querySelector('[data-quick-buy-size]');
      if (first) first.focus();
      return;
    }
    if (lengthBtn) {
      e.preventDefault();
      addToCart(lengthBtn, Number(lengthBtn.getAttribute('data-quick-buy-length')), overlay.dataset.fallback);
      return;
    }
    if (!sizeLink) return;
    e.preventDefault();

    var variants = variantsFor(overlay, data, sizeLink.getAttribute('data-quick-buy-size'));
    if (!variants.length) { window.location.href = sizeLink.href; return; }
    var pick = variants.filter(function (v) { return v.available; })[0] || variants[0];
    var fallback = sizeLink.href.split('?')[0] + '?variant=' + pick.id;
    overlay.dataset.fallback = fallback;

    var lengths = [];
    variants.forEach(function (v) {
      var l = lengthOf(data, v);
      if (l && !lengths.some(function (x) { return x.label === l; })) lengths.push({ label: l, variant: v });
    });
    if (lengths.length < 2) { addToCart(sizeLink, pick.id, fallback); return; }

    var list = overlay.querySelector('[data-quick-buy-length-list]');
    list.innerHTML = '';
    lengths.forEach(function (l) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tfa-card__size';
      btn.textContent = l.label;
      btn.setAttribute('data-quick-buy-length', l.variant.id);
      if (!l.variant.available) btn.disabled = true;
      list.appendChild(btn);
    });
    showStep(overlay, true);
    // Keyboard users (click without a pointer) continue in the new step
    var firstLength = list.querySelector('button:not([disabled])');
    if (firstLength && e.detail === 0) firstLength.focus();
  });

  // Leaving the photo resets the overlay to the sizes.
  document.addEventListener('mouseleave', function (e) {
    if (!e.target.classList || !e.target.classList.contains('tfa-card__media-wrap')) return;
    var overlay = e.target.querySelector('[data-quick-buy]');
    if (!overlay) return;
    if (overlay.contains(document.activeElement)) document.activeElement.blur();
    showStep(overlay, false);
  }, true);

  function init(root) { (root || document).querySelectorAll('[data-product-card]').forEach(initCard); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
